// extracted by mini-css-extract-plugin
module.exports = {"TopGG":"styles_TopGG__nP__D","subheading":"styles_subheading__Blgua","heading":"styles_heading__tweRR","pink":"styles_pink__OiQW2","purple":"styles_purple__67Cvp"};